import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "multi-row-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("rect", {
        fill: "none",
        height: "24",
        width: "24",
        y: "0"
      })
    ], -1),
    _createElementVNode("g", null, [
      _createElementVNode("g", null, [
        _createElementVNode("path", { d: "M5,11h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1H5C4.45,5,4,5.45,4,6v4C4,10.55,4.45,11,5,11z M5,18h3c0.55,0,1-0.45,1-1 v-4c0-0.55-0.45-1-1-1H5c-0.55,0-1,0.45-1,1v4C4,17.55,4.45,18,5,18z M11,18h3c0.55,0,1-0.45,1-1v-4c0-0.55-0.45-1-1-1h-3 c-0.55,0-1,0.45-1,1v4C10,17.55,10.45,18,11,18z M17,18h3c0.55,0,1-0.45,1-1v-4c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1v4 C16,17.55,16.45,18,17,18z M11,11h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1v4C10,10.55,10.45,11,11,11z M16,6v4c0,0.55,0.45,1,1,1h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3C16.45,5,16,5.45,16,6z" })
      ])
    ], -1)
  ])))
}
export default { render: render }